// A background sync of one part (e.g. reports after sending orders) must not
// block syncing the others, so only parts that are idle count as syncable.
export const getSyncableKeys = (keys, loadingMap) =>
  (keys || []).filter((key) => !loadingMap?.[key]);
